import { type PracticeMigrationEssentials } from '@principle-theorem/practice-migrations/interfaces';
import { EXACT_DESTINATION } from './destination';
import { EXACT_MAPPINGS } from './mappings';
import { EXACT_SOURCE_V2 } from './source-v2';

export const EXACT_MIGRATION_V2: PracticeMigrationEssentials = {
  metadata: {
    name: 'Exact',
    version: 'v2',
    supportsMultiplePractices: false,
  },
  source: EXACT_SOURCE_V2,
  destination: EXACT_DESTINATION,
  mappings: EXACT_MAPPINGS,
};
